import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getWindow } from 'ssr-window';
import classNames from 'classnames';
import { useEventWebinarContext } from './EventWebinarContext';

const SocialMediaIntent = ({ className, children, href, title, target, isSocialShare = true }) => (
  <li className={className}>
    <a
      href={href}
      target={target}
      title={title}
      className={classNames('btn btn-icon-tertiary btn-light-theme non-default-link', {
        'js-social-share-button': isSocialShare
      })}
    >
      <span className="icon-wrapper">{children}</span>
    </a>
  </li>
);

const SocialMediaIntentWithNoUnderline = styled(SocialMediaIntent)`
  .icon-wrapper {
    height: 3.3rem;
    width: 3.3rem;
    color: var(--cta-blue);
    background: transparent;
    border: 1px solid var(--cta-blue);
  }

  .btn-icon-tertiary::after {
    display: none;
    content: none;
  }
`;

const SocialMediaIntentList = ({ className, eventTypeDisplayName }) => {
  const { title } = useEventWebinarContext();
  const window = getWindow();
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(window.location.href);
  }, [window]);

  return (
    <ul className={classNames('non-bdo-style-list', className)} aria-labelledby="social-share">
      <SocialMediaIntentWithNoUnderline
        href={`mailto:?subject=${title}&body=${url}`}
        target="_blank"
        title={`Email this ${eventTypeDisplayName}`}
        isSocialShare={false}
      >
        <span className="material-icons-outlined">email</span>
      </SocialMediaIntentWithNoUnderline>
      <SocialMediaIntentWithNoUnderline
        href={`https://www.facebook.com/sharer/sharer.php?u=${url};src=sdkpreparse`}
        title="Facebook"
      >
        <span className="social-icon ico-facebook" />
      </SocialMediaIntentWithNoUnderline>
      <SocialMediaIntentWithNoUnderline
        href={`https://www.twitter.com/intent/tweet?url=${url}&text=${title}`}
        title="X"
      >
        <span className="social-icon ico-x-logo" />
      </SocialMediaIntentWithNoUnderline>
      <SocialMediaIntentWithNoUnderline
        href={`https://www.linkedin.com/sharing/share-offsite?mini=true&url=${url}&title=${title}`}
        title="LinkedIn"
      >
        <span className="social-icon ico-linkedin" />
      </SocialMediaIntentWithNoUnderline>
    </ul>
  );
};

const StyledSocialMediaIntentList = styled(SocialMediaIntentList)`
  margin-block: 1.6rem;
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
`;

export default StyledSocialMediaIntentList;
